import { render, staticRenderFns } from "./SearchType.vue?vue&type=template&id=1877165e&scoped=true"
import script from "./SearchType.vue?vue&type=script&lang=js"
export * from "./SearchType.vue?vue&type=script&lang=js"
import style0 from "./SearchType.vue?vue&type=style&index=0&id=1877165e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1877165e",
  null
  
)

export default component.exports